import { render, staticRenderFns } from "./epb-bulk-action-toolbar.component.vue?vue&type=template&id=a389f9c8&scoped=true"
import script from "./epb-bulk-action-toolbar.component.vue?vue&type=script&lang=ts"
export * from "./epb-bulk-action-toolbar.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-bulk-action-toolbar.component.vue?vue&type=style&index=0&id=a389f9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a389f9c8",
  null
  
)

export default component.exports